//----------------------------\\
//---- Popup et sidepanel ----\\
//----------------------------\\

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Ici on retrouve tout ce qui a attrait au popup et au sidepanel (popup de connexion, menu mobile)
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////

// Importation ----------------------------------------------------------------------------------------------------
import $ from 'jquery'
import { Overlay } from './../classes/overlay.js'
import { copyTextToClipboard , fallbackCopyTextToClipboard } from './functions.js'
//-----------------------------------------------------------------------------------------------------------------


// Fonction gérant le menu mobile
export function overlayMenu() {
  const overlayMenu = new Overlay('overlayMenu', '.btnMenu', 'showOverlayMenu', '#overlay-menu .closeOverlay, .btnSearch')

  $('.btnSubLvl1 > a').on('click', function() {
    // Fermeture de tout avant d'en ouvrir un autre
    if (!$(this).parent().hasClass('active')) {
      $('.btnSubLvl1').removeClass('active')
      $('.subLvl1').animate({ height: 'hide' }, { duration: 400, specialEasing: { height: 'easeInOutCubic' }})
      $('.subLvl1').removeClass('open')
    }
    // Gestion ouverture et fermeture
    if (!$(this).parent().find('.subLvl1').hasClass('open')) {
      $(this).parent().find('.subLvl1').addClass('open')
      $(this).parent().find('.subLvl1').animate({ height: 'show' }, { duration: 400, specialEasing: { height: 'easeInOutCubic' }})
      $(this).parent().addClass('active')
    } else {
      $(this).parent().find('.subLvl1').removeClass('open')
      $(this).parent().find('.subLvl1').animate({ height: 'hide' }, { duration: 400, specialEasing: { height: 'easeInOutCubic' }})
      $(this).parent().removeClass('active')
    }
  })
  $('#overlay-menu .subLvl1 a').on('click', function() {
    $('.btnMenu').trigger('click')
  })
}


// Fonction gérant le rideau des liens rapides
export function overlayFastLinks() {
  const overlayFastLinks = new Overlay('overlayFastLinks', '.btnFastLinks', 'showOverlayFastLinks', '#overlay-fastLinks .closeOverlay', 600, true, false)
}


// Fonction gérant le popup de partage
export function overlayShare() {

  if ( typeof __sharethis__ != 'undefined' ) {

    if (__sharethis__.customRefresh === true) {
      __sharethis__.init(__sharethis__.config)
    } else {
      __sharethis__.customRefresh = true
    }
  }

  const overlayShare = new Overlay('overlayShare', '.btnShare', 'showOverlayShare', '#overlay-share .closeOverlay', 600, true, false)


  $('.btnShare').click( function() {
    var attr = $(this).attr('data-url')
    if (typeof attr !== typeof undefined && attr !== false) {
      $('#overlay-share ul > li > a').attr('data-url', document.domain+attr)
    }else{
      $('#overlay-share ul > li > a').attr('data-url', window.location.href)
    }
    $('#emailShareBtn').attr('href','mailto:?Subject=Saint-Esprit&body='+encodeURIComponent(document.domain+attr))
  })

  $('#copyShareBtn').click( function() {
    var link = $(this).data('url')
    copyTextToClipboard($(this).data('url'))
    alert('Un url a été copié sur votre presse-papiers.')
    return false
  })
}


// Fonction gérant le rideau de la recherche
export function overlaySearch() {
  const overlaySearch = new Overlay('overlaySearch', '.btnSearch', 'showOverlaySearch', '#overlay-search .closeOverlay', 600, true, false)
  $('.btnSearch').click(function() {
    setTimeout(function(){ //Besoin de mettre un timer pour faire fonctionner le focus, pourquoi? je ne sais pas
      $('#searchInput').focus()
    }, 100)
  })
}


// Fonction gérant le popup du calendrier en mobile
export function overlayCalendar() {
  const overlayCalendar = new Overlay('overlayCalendar', '.btnCalendar', 'showOverlayCalendar', '#overlay-calendar .closeOverlay', 600, true, false)
}

// Fonction gérant le drop down du header
export function dropDownHeader() {
  var activeDropDown = '', delay = 0, setTimeoutConst

  var close = () => {
    delay = 0
    if ( !($('html').hasClass('isMobile'))) {
      $('#overlay-dropDown').animate({ height: 0 }, { queue: false, duration: 700, specialEasing: { height: 'easeOutExpo' }})
    }
    $('html').removeClass(activeDropDown).removeClass('showOverlayDropDown')
  }

  $('header .mainLinks a').hover(function () {
    var self = $(this)
    var height1 = $('[data-links="municipalite"]').height()
    var height2 = $('[data-links="citoyens"]').height()
    var height3 = $('[data-links="loisirs"]').height()
    var maxHeight = Math.max(height1, height2, height3)

    setTimeoutConst = setTimeout(() => {
      delay = 300
      $('html').addClass('showOverlayDropDown').removeClass(activeDropDown)
      activeDropDown = self.data('section')
      $('html').addClass(activeDropDown)
      $('#overlay-dropDown').animate({ height: maxHeight < 400 ? 400 : maxHeight }, { queue: false, duration: 700, specialEasing: { height: 'easeOutExpo' }})
    }, delay)
  }, () => {
    clearTimeout(setTimeoutConst)
  })

  $('.dropDownOverlay, header .rightLinks, header .logo').on('mouseover', () => { close() })
  $('#overlay-dropDown a').on('click', () => { close() })
}
